import { createTheme } from "@mui/material/styles";
import { defaultTheme } from "@viajero/shared-ui/theme";
import { colors } from "@/theme/colors";

// ゲストアプリ用 MUI テーマ。shared-ui の defaultTheme を継承し、
// primary (#28233B) / secondary (#C9A063) を上書きする。
// ブレイクポイントは MUI デフォルトを使用する (xs=SP, sm=Tablet, md=PC 以上)。
export const guestTheme = createTheme(defaultTheme, {
  palette: {
    primary: {
      main: "#28233B",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: colors.gold,
      // main のみ上書きすると dark/light は defaultTheme の MUI 既定色 (紫) が残り、
      // contained ボタンの hover 等が紫になる。gold トーンを明示する。
      light: colors.goldLight,
      dark: colors.goldDark,
      contrastText: "#FFFFFF",
    },
    background: {
      default: "#F8F6F2",
      paper: "#FFFFFF",
    },
    // ErrorStateView (@viajero/shared-ui/error-boundary) の配色。
    errorState: {
      error: colors.danger,
      warning: colors.gold,
      info: colors.textSub,
      title: colors.text,
      body: colors.textBody,
    },
  },
  typography: {
    fontFamily: '"Noto Sans JP", system-ui, -apple-system, sans-serif',
    // ゲストアプリは年配層の閲覧も想定し、shared-ui の基準 (14px) より大きい 16px を基準にする。
    fontSize: 16,
    body1: { fontSize: 16 },
    body2: { fontSize: 16 },
    button: { fontSize: 16 },
  },
});
